import React from 'react';
import StatsGrid from './statsGrid';
import NewsList from './LatestNewsList';


const DashboardHome = ({ 
  paginatedNews, 
  newsCurrentPage, 
  newsTotalPages, 
  setNewsCurrentPage 
}) => {
  return (
    <div>
      <div className="page-header">
        <h2>لوحة التحكم الرئيسية</h2>
        <p>مرحباً بك في نظام إدارة المحتوى</p>
      </div>

      <StatsGrid />

      <NewsList 
        paginatedNews={paginatedNews}
        newsCurrentPage={newsCurrentPage}
        newsTotalPages={newsTotalPages}
        setNewsCurrentPage={setNewsCurrentPage}
      />
    </div>
  );
};

export default DashboardHome;